import React from 'react';

const StatsSection: React.FC = () => {
  const stats = [
    { value: 'Built for CA', label: 'California-focused lease templates' },
    { value: '5 min', label: 'From draft to print' },
    { value: 'Free', label: 'Customizable lease templates' }
  ];

  return (
    <div className="stats-section" style={{
      background: '#F8F9FF',
      padding: '80px 0'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 24px'
      }}>
        <div className="stats-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          textAlign: 'center'
        }}>
          {stats.map((stat, index) => (
            <div key={index}>
              <div className="stat-value" style={{
                fontSize: 'clamp(2.25rem, 5vw, 3rem)',
                fontWeight: 700,
                color: '#0052FF',
                marginBottom: '8px'
              }}>
                {stat.value}
              </div>
              <div className="stat-label" style={{
                fontSize: 'clamp(0.875rem, 2vw, 1rem)',
                color: '#5B616E',
                fontWeight: 500
              }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .stats-section {
            display: none !important;
            padding: 60px 0 !important;
          }
          
          .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 32px !important;
            padding: 0 20px !important;
          }
          
          .stat-value {
            font-size: 2.25rem !important;
          }
          
          .stat-label {
            font-size: 0.875rem !important;
          }
        }

        @media (max-width: 480px) {
          .stats-section {
            padding: 50px 0 !important;
          }
          
          .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 24px !important;
            padding: 0 16px !important;
          }
          
          .stat-value {
            font-size: 1.875rem !important;
          }
          
          .stat-label {
            font-size: 0.8rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default StatsSection;
